import { render, staticRenderFns } from "./MainCommunitySettings.vue?vue&type=template&id=658d7b62&scoped=true&"
import script from "./MainCommunitySettings.vue?vue&type=script&lang=js&"
export * from "./MainCommunitySettings.vue?vue&type=script&lang=js&"
import style0 from "./MainCommunitySettings.vue?vue&type=style&index=0&id=658d7b62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658d7b62",
  null
  
)

export default component.exports